import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Common/Breadcrumb';

const About = () => {
  const whatWeDo = [
    {
      id: 1,
      title: "Immigration Services",
      description: "End-to-end support for Work Permits, PR, Visitor Visas, and Sponsorships.",
      icon: "fas fa-passport"
    },
    {
      id: 2,
      title: "Business Setup",
      description: "Assistance with Canadian company registration, compliance, and licensing.",
      icon: "fas fa-building"
    },
    {
      id: 3,
      title: "Ongoing Support",
      description: "Services for accounting, renewals, and ongoing legal needs.",
      icon: "fas fa-headset"
    }
  ];

  const whyChooseUs = [
    "Experienced & Licensed Experts",
    "Personalized Case Handling",
    "Transparent Communication",
    "End-to-End Support"
  ];

  return (
    <>
      <Breadcrumb title="About Us" />


      {/* Who We Are Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="display-5 text-primary mb-4">Who We Are</h2>
              <p className="text-muted fs-5 lh-lg">
                We are a passionate team committed to helping individuals, families, and businesses navigate Canada's immigration system and establish successful ventures. Our mission is to simplify the journey with expert guidance, personalized service, and a deep understanding of Canadian policies.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* What We Do Section */}
      <div className="container-fluid bg-light py-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <h2 className="display-5 text-primary mb-4">What We Do</h2>
            <p className="text-muted fs-5">Comprehensive solutions for your immigration and business needs</p>
          </div>
          
          <div className="row g-4">
            {whatWeDo.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${service.id * 0.1}s`}>
                <div className="service-card h-100 bg-white rounded shadow-sm p-4 border-0 hover-lift text-center">
                  <div className="mb-4">
                    <div className="service-icon bg-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                      <i className={`${service.icon} fa-2x text-white`}></i>
                    </div>
                  </div>
                  <h4 className="text-primary mb-3">{service.title}</h4>
                  <p className="text-muted mb-0">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
              <h2 className="display-5 text-primary mb-4">Why Choose Us</h2>
              <div className="row g-3">
                {whyChooseUs.map((item, index) => (
                  <div key={index} className="col-12 d-flex align-items-center">
                    <div className="me-3">
                      <i className="fas fa-check-circle text-secondary fa-2x"></i>
                    </div>
                    <h5 className="text-dark mb-0">{item}</h5>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
              <div className="bg-light rounded p-4">
                <img src="/assets/img/chooseus.png" className="img-fluid rounded" alt="About Us" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container-fluid bg-light">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="text-primary mb-4">Ready to begin your journey?</h2>
              <p className="text-muted fs-5 mb-4">Let us help you achieve your dreams in Canada.</p>
              <Link to="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About; 